/// <reference path="../../node_modules/@types/shopify-buy/index.d.ts" />
function isInViewport (el: HTMLElement) {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
function setupCarousels() {
	document.querySelectorAll<HTMLElement>(".sa-carousel").forEach(carousel => {
		let horses = carousel.querySelectorAll<HTMLElement>(".sa-carousel-horses-horse");
		let buttons = carousel.querySelectorAll<HTMLButtonElement>("button.sa-carousel-controls-button");
		buttons.forEach(button => button.addEventListener("click", event => {
			let active = carousel.querySelector<HTMLButtonElement>("button.sa-carousel-controls-button.sa--active");
			if (active) {
				active.classList.remove("sa--active");
			}
			let index = parseInt(button.dataset.index);
			horses[index].scrollIntoView({
				block: "nearest",
				inline: "start",
				behavior: "smooth",
			});
			button.classList.add("sa--active");
		}));
		let interval = window.setInterval(function () {
			if (isInViewport(carousel)) {
				let active = carousel.querySelector<HTMLButtonElement>("button.sa-carousel-controls-button.sa--active");
				let index = parseInt(active.dataset["index"]);
				let target = index + 1 < buttons.length ? index + 1 : 0;
				buttons.item(target).click();
			}
		}, 10000);
	});
}
function setupClipboards() {
	document.querySelectorAll<HTMLButtonElement>("button[data-clipboard=\"copy\"]").forEach(button => {
		let text = button.querySelector("[data-clipboard-text]").textContent;
		button.title = `Copy ${text} to clipboard`;
		button.addEventListener("click", event => {
			navigator.clipboard.writeText(text);
			button.title = "Copied!";
			button.disabled = true;
		});
	});
}
function setupSiteHeaderMenu() {
	let button = document.querySelector(".sa-site-header-button") as HTMLButtonElement;
	let menu = document.querySelector(".sa-site-header-menu") as HTMLDivElement;
	button.addEventListener("click", function (event) {
		button.textContent = menu.classList.toggle("sa--open") ? "Close" : "Menu";
	});
	menu.querySelectorAll("a[href]").forEach((link: HTMLAnchorElement) => {
		if (new URL(link.href).pathname === window.location.pathname) {
			link.classList.add("sa--current");
		}
	});
}
function setupSamplePlayer() {
	document.querySelectorAll(".sa-player").forEach((player: HTMLDivElement) => {
		let playPause = player.querySelector(".sa-player-control-play_pause") as HTMLButtonElement;
		let artist = player.querySelector(".sa-player-control-artist") as HTMLSpanElement;
		let title = player.querySelector(".sa-player-control-title") as HTMLSpanElement;
		let elapsed = player.querySelector(".sa-player-control-timestamp-elapsed") as HTMLSpanElement;
		let duration = player.querySelector(".sa-player-control-timestamp-duration") as HTMLSpanElement;
		let timeline = player.querySelector(".sa-player-control-timeline") as HTMLProgressElement;
		let list = player.querySelector(".sa-player-list");
		var audio: HTMLAudioElement;
		var animation: number;
		let playNextTrack = function () {
			let next = audio.parentElement.nextElementSibling as HTMLLIElement;
			if (next) {
				playTrack(next);
			}
		}
		let playTrack = function (sample: HTMLLIElement) {
			if (audio) {
				audio.pause();
				audio.currentTime = 0;
				cancelAnimationFrame(animation);
				audio.removeEventListener("ended", playNextTrack);
			}
			audio = sample.querySelector("audio")
			artist.textContent = audio.dataset.artist;
			title.textContent = audio.dataset.title;
			elapsed.textContent = "0:00";
			duration.textContent = `${Math.floor(audio.duration / 60)}:${Math.ceil(audio.duration % 60)}`;
			timeline.value = 0;
			timeline.max = audio.duration;
			audio.play();
			playPause.setAttribute("aria-pressed", "true");
			let tickPlayer = function (time: DOMHighResTimeStamp) {
				timeline.value = audio.currentTime;
				elapsed.textContent = `${Math.floor(audio.currentTime / 60)}:${Math.ceil(audio.currentTime % 60).toString().padStart(2, "0")}`;
				requestAnimationFrame(tickPlayer);
			};
			animation = requestAnimationFrame(tickPlayer);
			audio.addEventListener("ended", playNextTrack);
		}
		player.querySelectorAll(".sa-player-list-sample").forEach((sample: HTMLLIElement) => sample.addEventListener("click", () => playTrack(sample)));
		playPause.addEventListener("click", function (event) {
			if (!audio) {
				playTrack(list.firstElementChild as HTMLLIElement);
			} else {
				if (audio.paused) {
					audio.play();
					playPause.setAttribute("aria-pressed", "true");
				} else {
					audio.pause();
					playPause.setAttribute("aria-pressed", "false");
				}
			}
		});
		timeline.addEventListener("click", function (event) {
			if (audio) {
				let bcr = this.getBoundingClientRect();
				audio.currentTime = audio.duration * ((event.clientX - bcr.left) / bcr.width);
			}
		});
	});
}
document.addEventListener("DOMContentLoaded", async function (event) {
	setupSiteHeaderMenu();
	setupSamplePlayer();
	setupCarousels();
	setupClipboards();
});
